import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { fmtBytes } from './ownerApi';

export const NA = 'Bilgi alınamadı';
const fmtUsd = (v) => {
  if (v == null) return NA;
  if (v === 0) return '$0.00';
  if (v < 0.000001) return '< $0.000001';
  return v < 0.01 ? `$${Number(v.toPrecision(2))}` : `$${v.toFixed(2)}`;
};
export const fmtTime = (iso) => new Date(iso).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' });

const Row = ({ label, value, testId }) => (
  <div className="flex justify-between gap-3"><dt className="text-slate-500">{label}</dt><dd className="text-right font-medium" data-testid={testId}>{value}</dd></div>
);

const Block = ({ title, note, children, testId }) => (
  <div className="border-t border-slate-100 pt-4" data-testid={testId}>
    <p className="text-xs font-semibold tracking-wide text-slate-400">{title}</p>
    <dl className="mt-2 space-y-1.5 text-sm">{children}</dl>
    {note && <p className="mt-1.5 text-xs text-slate-400">{note}</p>}
  </div>
);

export const GcsBlock = ({ g }) => (
  <Block title="GOOGLE CLOUD STORAGE" testId="owner-storage-gcs" note={g ? `Klasör: ${g.prefix}${g.partial ? ' · çok fazla dosya, sayım kısmi' : ''}` : null}>
    {g ? <><Row label="Dosya sayısı" value={g.count.toLocaleString('tr-TR')} testId="owner-storage-gcs-count" /><Row label="Toplam boyut" value={fmtBytes(g.bytes)} testId="owner-storage-gcs-size" /></>
      : <Row label="Durum" value={NA} testId="owner-storage-gcs-na" />}
  </Block>
);

export const MongoBlock = ({ m }) => (
  <Block title="MONGODB" testId="owner-storage-mongo">
    {m ? <><Row label="Toplam" value={fmtBytes(m.total_bytes)} testId="owner-storage-mongo-total" /><Row label="Veri" value={fmtBytes(m.data_bytes)} testId="owner-storage-mongo-data" />
      <Row label="İndeks" value={fmtBytes(m.index_bytes)} testId="owner-storage-mongo-index" /><Row label="Ayrılmış alan" value={fmtBytes(m.storage_bytes)} testId="owner-storage-mongo-storage" /></>
      : <Row label="Durum" value={NA} testId="owner-storage-mongo-na" />}
  </Block>
);

export const LegacyBlock = ({ l }) => (
  <Block title="EMERGENT ESKİ DOSYALAR" testId="owner-storage-legacy" note={l ? 'Veritabanı kayıtlarından hesaplanır; depo taranmaz. Henüz Google Cloud\'a aktarılmadı.' : null}>
    {l ? <><Row label="Dosya sayısı" value={l.count.toLocaleString('tr-TR')} testId="owner-storage-legacy-count" />
      <Row label="Boyut" value={l.count_unknown_size ? `${fmtBytes(l.bytes_known)} + ${l.count_unknown_size} dosya bilinmiyor` : fmtBytes(l.bytes_known)} testId="owner-storage-legacy-size" /></>
      : <Row label="Durum" value={NA} testId="owner-storage-legacy-na" />}
  </Block>
);

export const CostBlock = ({ c, onSave, saving }) => {
  const [v, setV] = useState(String(c.usd_per_gb_month));
  return (
    <Block title="TAHMİNİ GOOGLE CLOUD MALİYETİ" testId="owner-storage-cost" note="Yalnız depolama. API işlemleri ve veri transferi hariçtir.">
      <Row label="Aylık (USD)" value={fmtUsd(c.monthly_usd)} testId="owner-storage-cost-monthly" />
      <div className="flex items-center justify-between gap-2 pt-1">
        <label htmlFor="gcs-price" className="text-slate-500">Fiyat (USD / GB·ay, Frankfurt Standard)</label>
        <div className="flex items-center gap-1.5">
          <Input id="gcs-price" value={v} onChange={(e) => setV(e.target.value)} className="h-8 w-20 text-right" inputMode="decimal" data-testid="owner-storage-price-input" />
          <Button size="sm" variant="outline" className="h-8" disabled={saving || Number(v.replace(',', '.')) === c.usd_per_gb_month}
            onClick={() => onSave(Number(v.replace(',', '.')))} data-testid="owner-storage-price-save">Kaydet</Button>
        </div>
      </div>
    </Block>
  );
};
